module.exports = require("@material/form-field/dist/mdc.formField");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/form-field/dist/mdc.formField","commonjs2":"@material/form-field/dist/mdc.formField","commonjs":"@material/form-field/dist/mdc.formField","amd":"@material/form-field/dist/mdc.formField","umd":"@material/form-field/dist/mdc.formField"}
// module id = 24
// module chunks = 0